import { render, staticRenderFns } from "./credit-regist.vue?vue&type=template&id=bc28e922&scoped=true&"
import script from "./credit-regist.vue?vue&type=script&lang=js&"
export * from "./credit-regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc28e922",
  null
  
)

export default component.exports